import React, { useEffect, useState, useRef, useCallback } from "react";
import Connect from "../../../shared/redux/Connect.hoc";
import { withRouter } from "react-router-dom";
// import Modal from 'react-bootstrap4-modal'
import {Modal} from 'react-bootstrap';
import LoaderSpinner from '../../../shared/components/LoaderSpinner/LoaderSpinner'
import { createNotification } from '../../../utils/utils'


import { recoverPasswordHP } from '../../../helpers/Cliente.helper'
import './styles.scss'
import InputIcon from "../../../shared/atoms/input icon";
import {AiOutlineMail} from 'react-icons/ai';
import Button from "../../../shared/atoms/button";


const RecoverPass = ({ dispatch, visibleForget, onCloseForget, onRecover }) => {
  const [showLoading, setShowLoading] = useState(false)
  const [alertState, updateAlertState] = useState(false)
  const [alertMessage, updateAlertMessage] = useState('')

  const formRef = useRef(null)

  useEffect(() => {
    console.log("--RecoverPass.Component.useEffect--")

  }, []);

  const closeModal = () => {
    console.log("--RecoverPass.Component.closeModal--")
    onCloseForget()
  }

  const showAlert = (message) => {
    console.log("--Signin.Component.showAlert-- message: ", message)
    updateAlertState(true)
    updateAlertMessage(message)
    setTimeout(() => {
      updateAlertState(false)
    }, 3000)
  }

  const apiRecover = async (body) => {
    console.log("--RecoverPass.Component.apiRecover-- body: ", body)
    try {
      const response = await recoverPasswordHP(body)
      if (response['code'] === 400) {
        showAlert(response['message'])
      } else {
        createNotification('La contraseña ha sido reestablecida, revisa tu email', 'success')
        onRecover()
        console.log("RecoverPass.Component.apiRecover response: ", response)
      }
      setShowLoading(false)
    } catch (error) {
      console.error("--RecoverPass.Component.apiRecover-- error: ", error)
    }
  }

  const handleRecover = useCallback(
    async event => {
      setShowLoading(true)
      event.preventDefault()
      console.log("--RecoverPass.Component.handleRecover--")
      const { email } = event.target.elements
      if (email == '') {
        showAlert('Debes ingresar un email válido')
      }
      setShowLoading(true)
      let formData = {
        email: email.value
      }
      console.log('--RecoverPass.Comoponent.handleRecover-- formData: ', formData)
      try {
        await apiRecover(formData)

      } catch (error) {
        console.error('--RecoverPass.Comoponent.handleRecover-- error: ', error)
        setShowLoading(false)
      }


    }, [])

  return (

    <Modal
    aria-labelledby="contained-modal-title-vcenter"
    show={visibleForget}
    centered
    onHide={() => closeModal()}
  >
    <Modal.Header closeButton>
      <Modal.Title style={{fontWeight: 'bold'}} className="ms-auto">
        Restablecer contraseña 
      </Modal.Title>
    </Modal.Header>
      <hr/>
    <Modal.Body>
      <form className="RecoverPass-Form">
        <InputIcon Icon={AiOutlineMail} placeholder="Email" name = "email" type= "email" required={true}/>

        <Button name="Enviar" />
      </form>
    </Modal.Body>
  </Modal>

    // <Modal visible={visibleForget} onClickBackdrop={closeModal}>
    //   {showLoading &&
    //     <LoaderSpinner show={showLoading} />
    //   }
    //   <div className="modal-header text-center">
    //     <h1 className="title-modal" style={{ fontFamily: "Montserrat" }}>Restablecer Contraseña</h1>
    //     <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={closeModal} >
    //       <span aria-hidden="true">&times;</span>
    //     </button>
    //   </div>
    //   <div className="modal-body">
    //     <div >
    //       <div >
    //         <form onSubmit={handleRecover} ref={formRef}>
    //           <div className="form-group">
    //             <label htmlFor='email' className='fields-input' style={{ fontFamily: " Montserrat", color: "#858585" }}>Correo Electrónico *</label>
    //             <input
    //               className="form-control"
    //               name='email'
    //               type='email'
    //               id='user-emailInput'
    //               required
    //               placeholder='Correo Electrónico' />
    //           </div>

    //           {alertState &&
    //             <div className="alert alert-danger mt-3" role="alert">
    //               {alertMessage}
    //             </div>
    //           }
    //           <div className="form-row text-center mb-3 mt-5">
    //             <div className="col-12">
    //               <button type="submit" className="btn btn-primary">Recuperar</button>
    //             </div>
    //           </div>
    //         </form>
    //       </div>
    //     </div>
    //   </div>
    // </Modal>
  )
}

export default Connect(RecoverPass)

